import './containers/Base.css'
import './containers/Game.css'
import React from 'react'
import { connect } from 'react-redux'
import Activity from './containers/Activity'
import Party from './containers/Party'

const ViewerRoot = (props) => {
  const { game } = props

  return (
    <div className="Game">
      <div className="Game__party">
        <Party />
      </div>
      <div className="Game__layout">
        <div className="Game__activity">
          <Activity />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  game: state.game
})

export default connect(mapStateToProps)(ViewerRoot)